export const API = "https://plankton-app-hrtui.ondigitalocean.app";
